export default "__VITE_ASSET__DEa8OOBQ__"